/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_ActionsInputs */

const th_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทางลัด`)
};

const en_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick actions`)
};

const ja_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クイック操作`)
};

const zh_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快捷操作`)
};

const es_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones rápidas`)
};

const pt_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações rápidas`)
};

const id_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksi cepat`)
};

const fr_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions rapides`)
};

const tl_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mabilisang aksyon`)
};

const vi_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thao tác nhanh`)
};

const ko_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빠른 작업`)
};

const de_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellaktionen`)
};

const ru_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Быстрые действия`)
};

const tr_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hızlı işlemler`)
};

const it_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni rapide`)
};

const pl_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szybkie działania`)
};

const uk_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Швидкі дії`)
};

const hi_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्वरित क्रियाएँ`)
};

const ar_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجراءات سريعة`)
};

const ms_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tindakan pantas`)
};

const bn_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দ্রুত কাজ`)
};

const zh_tw2_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速操作`)
};

const zh_hk2_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速操作`)
};

const ur_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فوری کارروائیاں`)
};

const fa_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کارهای سریع`)
};

const sw_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitendo vya haraka`)
};

const nl_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snelle acties`)
};

/**
* | output |
* | --- |
* | "Quick actions" |
*
* @param {Quick_ActionsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const quick_actions = /** @type {((inputs?: Quick_ActionsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_ActionsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_quick_actions(inputs)
	if (locale === "ja") return ja_quick_actions(inputs)
	if (locale === "zh") return zh_quick_actions(inputs)
	if (locale === "es") return es_quick_actions(inputs)
	if (locale === "pt") return pt_quick_actions(inputs)
	if (locale === "id") return id_quick_actions(inputs)
	if (locale === "fr") return fr_quick_actions(inputs)
	if (locale === "tl") return tl_quick_actions(inputs)
	if (locale === "vi") return vi_quick_actions(inputs)
	if (locale === "ko") return ko_quick_actions(inputs)
	if (locale === "de") return de_quick_actions(inputs)
	if (locale === "ru") return ru_quick_actions(inputs)
	if (locale === "tr") return tr_quick_actions(inputs)
	if (locale === "it") return it_quick_actions(inputs)
	if (locale === "pl") return pl_quick_actions(inputs)
	if (locale === "uk") return uk_quick_actions(inputs)
	if (locale === "hi") return hi_quick_actions(inputs)
	if (locale === "ar") return ar_quick_actions(inputs)
	if (locale === "ms") return ms_quick_actions(inputs)
	if (locale === "bn") return bn_quick_actions(inputs)
	if (locale === "zh-TW") return zh_tw2_quick_actions(inputs)
	if (locale === "zh-HK") return zh_hk2_quick_actions(inputs)
	if (locale === "ur") return ur_quick_actions(inputs)
	if (locale === "fa") return fa_quick_actions(inputs)
	if (locale === "sw") return sw_quick_actions(inputs)
	if (locale === "nl") return nl_quick_actions(inputs)
	return en_quick_actions(inputs)
});